// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-container {
  width: 830px;
  margin: 0 auto;
  overflow-x: auto;
}

.admin-tournament {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.admin-round {
  display: flex;
  flex-direction: column;
  width: 200px;
  list-style: none;
  padding: 0;
}
.admin-round .admin-spacer { flex-grow: 1; }
.admin-round .admin-game-spacer { flex-grow: 1; }

/* Games */
li.admin-game {
  padding-left: 20px;
}
li.admin-game.winner {
  font-weight: bold;
  font-size: medium;
  color: rgb(143, 28, 215);
}
li.admin-game-top { border-bottom: 1px solid #aaa; }
li.admin-game-bottom { border-top: 1px solid #aaa; }
li.admin-game-spacer { border-right: 1px solid #aaa; min-height: 50px; }

/* Round spacings */
.admin-round.admin-round-2 li.admin-spacer { min-height: 65px; }
.admin-round.admin-round-2 li.admin-game-spacer { min-height: 160px; }

.admin-round.admin-round-3 li.admin-spacer { min-height: 170px; }
.admin-round.admin-round-3 li.admin-game-spacer { min-height: 330px; }

.admin-round.admin-round-4 li.admin-spacer { min-height: 440px; }
.admin-round.admin-round-4 li.admin-game-spacer { min-height: 380px; }

.admin-round.admin-round-4 li.admin-game.winner {
  color: rgb(28, 213, 34);
}

.unsaved {
  border: 2px dashed orange;
  background-color: #fff7e6;
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminPlayoff.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA,6BAA6B,YAAY,EAAE;AAC3C,kCAAkC,YAAY,EAAE;;AAEhD,UAAU;AACV;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA,oBAAoB,6BAA6B,EAAE;AACnD,uBAAuB,0BAA0B,EAAE;AACnD,uBAAuB,4BAA4B,EAAE,gBAAgB,EAAE;;AAEvE,mBAAmB;AACnB,6CAA6C,gBAAgB,EAAE;AAC/D,kDAAkD,iBAAiB,EAAE;;AAErE,6CAA6C,iBAAiB,EAAE;AAChE,kDAAkD,iBAAiB,EAAE;;AAErE,6CAA6C,iBAAiB,EAAE;AAChE,kDAAkD,iBAAiB,EAAE;;AAErE;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":[".admin-container {\n  width: 830px;\n  margin: 0 auto;\n  overflow-x: auto;\n}\n\n.admin-tournament {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.admin-round {\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  list-style: none;\n  padding: 0;\n}\n.admin-round .admin-spacer { flex-grow: 1; }\n.admin-round .admin-game-spacer { flex-grow: 1; }\n\n/* Games */\nli.admin-game {\n  padding-left: 20px;\n}\nli.admin-game.winner {\n  font-weight: bold;\n  font-size: medium;\n  color: rgb(143, 28, 215);\n}\nli.admin-game-top { border-bottom: 1px solid #aaa; }\nli.admin-game-bottom { border-top: 1px solid #aaa; }\nli.admin-game-spacer { border-right: 1px solid #aaa; min-height: 50px; }\n\n/* Round spacings */\n.admin-round.admin-round-2 li.admin-spacer { min-height: 65px; }\n.admin-round.admin-round-2 li.admin-game-spacer { min-height: 160px; }\n\n.admin-round.admin-round-3 li.admin-spacer { min-height: 170px; }\n.admin-round.admin-round-3 li.admin-game-spacer { min-height: 330px; }\n\n.admin-round.admin-round-4 li.admin-spacer { min-height: 440px; }\n.admin-round.admin-round-4 li.admin-game-spacer { min-height: 380px; }\n\n.admin-round.admin-round-4 li.admin-game.winner {\n  color: rgb(28, 213, 34);\n}\n\n.unsaved {\n  border: 2px dashed orange;\n  background-color: #fff7e6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
